import template from './users-index.html'
export default {
	controller,
	controllerAs: 'vm',
	template,
}

/* @ngInject */
function controller($scope, $log, User) {
	var vm = this
	vm.$onInit = () => {
		//API methods

		//Scope Attributes
		vm.title = 'Users'
		vm.tabFilter = 'status_active'
		vm.sortedBy = 'first_name'
		vm.users = []

		User.findAll().then((users) => {
			User.bindAll({}, $scope, 'vm.users')
			return users
		})
	}
}
